<template>
  <div class="f-main bgImg container parent-dashboard">

    <div class="box" :style="wrapperStyle">
      <!-- 顶部 Hero（对齐设计稿风格，仅做样式升级） -->
      <div class="hero">
        <div class="hero-main">
          <div class="hero-left">
            <div class="hero-icon" aria-hidden="true">
              <i class="el-icon-user-solid" />
            </div>
            <div class="hero-titles">
              <div class="hero-badges">
                <span class="badge badge--soft">{{ 'Teacher View' }}</span>
                <span class="badge badge--accent">{{ studentsCount }} {{ $t('parentOrTeacher.bindingStudent') }}</span>
              </div>
              <h1 class="hero-title">
                {{
                   $t("parentOrTeacher.teacher")
                }}
              </h1>
              <p class="hero-sub">
                {{ $t("parentOrTeacher.welcome1") }}
                <span class="hero-name">{{ userInfo.username }}</span>
                {{ $t("parentOrTeacher.welcome2") }}
              </p>
            </div>
          </div>

          <div class="hero-stats">
            <div class="hero-stat">
              <span class="hero-stat-num">{{ studentsCount }}</span>
              <span class="hero-stat-label">{{ $t('parentOrTeacher.bindingStudent') }}</span>
            </div>
          </div>

          <div class="hero-actions">
            <button type="button" class="btn btn--primary" @click="toAddBinding">
              <i class="el-icon-plus" aria-hidden="true" />
              {{ $t("parentOrTeacher.addManagement") }}
            </button>
          </div>
        </div>

        <div class="hero-strip">
          <button type="button" class="strip-link is-active">
            <i class="el-icon-user" aria-hidden="true" /> Student Dashboard
          </button>
        </div>
      </div>

      <div class="section-head">
        <div class="section-head-left">
          <span class="section-tab">My Students</span>
          <span class="section-count">{{ studentsCount }} total</span>
        </div>
      </div>

      <div class="content">
        <div
          v-for="item in studentList"
          :key="item.id"
          class="card"
        >
          <div class="user">
            <div class="avatar-wrap">
              <img
                  :src="item.avatarUrl ||require('@/assets/image/parentOrTeacher/student-picture.png')"
                  alt=""
              />
            </div>
            <div class="name">
              <div class="student-name">{{ item.studentName }}</div>
              <div class="grade-line">
                <span class="grade-pill">{{ $t("parentOrTeacher.grade") }} {{ item.studentGrade }}</span>
                <span class="status-pill">• Active</span>
              </div>
            </div>
          </div>

          <div
            class="learning-progress"
            v-for="it in item.categoryLearningProgress.slice(0, 2)"
            :key="it.id"
          >
            <div class="category">
              <span class="name">{{ it.categoryName }}</span>
              <span class="progress">{{ Math.round(it.overallProgress * 100) }}%</span>
            </div>
            <el-progress
              :percentage="it.overallProgress * 100"
              :show-text="false"
              :stroke-width="8"
              color="#7c4dff"
              style="width: 100%"
            ></el-progress>
          </div>
          <div class="card-actions">
            <button type="button" class="btn-mini btn-mini--primary" @click.stop="selectStudent(item)">
              <i class="el-icon-view" aria-hidden="true" /> View Progress
            </button>
            <button type="button" class="btn-mini btn-mini--danger" @click.stop="deleteBing(item.relationId)">
              <i class="el-icon-delete" aria-hidden="true" /> Remove
            </button>
          </div>
        </div>
      </div>

    </div>
    <div class="footer">{{ $t("common.footer") }}</div>
    <add-binding ref="addBinding" @submit="getStudentList" />
    <div class="student-Details" v-if="selectStudentInfo">
      <div class="info">
        <div class="details">{{ $t("parentOrTeacher.details") }}</div>
        <i class="close el-icon-close" @click="close()" />
        <div class="delete" @click="deleteBing">
          <i class="el-icon-delete" />
          {{ $t("parentOrTeacher.delete") }}
        </div>
        <img
          :src="selectStudentInfo.avatarUrl || require('@/assets/image/parentOrTeacher/student-picture.png')"
          alt=""
        />
        <div class="student-name">{{ selectStudentInfo.studentName }}</div>
        <div class="grade">
          {{ $t("parentOrTeacher.grade")
          }}<span style="margin-left: 4px">{{
            selectStudentInfo.studentGrade
          }}</span>
        </div>
        <el-select v-model="pointCode" class="button" @change="handleCategoryChange">
          <el-option
            v-for="item in categoriesList"
            :key="item.id"
            :label="$i18n.locale === 'en' ? item.categoryName : item.categoryNameFr"
            :value="item.id">
          </el-option>
        </el-select>
        <div
          class="knowledge-chart"
          ref="knowledgeChart"
          v-loading="knowledgeLoading"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { deleteBing, getUserList, knowledgeStats } from '@/api/tutor/parentOrTeacher'
import AddBinding from '@/views/parentOrTeacher/AddBinding.vue'
import { boundCategories } from '@/api/tutor/student'
import * as echarts from 'echarts'

export default {
  name: 'index',
  components: { AddBinding },
  props: {
    scale: {
      type: Number,
      required: 1
    }
  },
  data () {
    return {
      studentList: [],
      selectStudentInfo: null,
      categoriesList: [],
      pointCode: '',
      knowledgeChart: null,
      knowledgeLoading: false
    }
  },
  computed: {
    ...mapState('user', {
      userInfo: (state) => state.userInfo
    }),
    wrapperStyle () {
      return {
        transform: `scale(${this.scale})`,
        transformOrigin: 'top center'
      }
    },
    /**
     * 受管学生数量
     * @returns {number}
     */
    studentsCount () {
      return Array.isArray(this.studentList) ? this.studentList.length : 0
    },
    /**
     * 学科数量（取第一个学生的学科进度维度，避免误导）
     * @returns {number}
     */
    subjectsCount () {
      const first = Array.isArray(this.studentList) ? this.studentList[0] : null
      const list = first && Array.isArray(first.categoryLearningProgress) ? first.categoryLearningProgress : []
      return list.length
    },
    /**
     * Active 学生数量（任一学科进度 > 0 视为 active）
     * @returns {number}
     */
    activeStudentsCount () {
      const list = Array.isArray(this.studentList) ? this.studentList : []
      return list.filter((s) => {
        const cps = Array.isArray(s.categoryLearningProgress) ? s.categoryLearningProgress : []
        return cps.some((c) => Number(c.overallProgress || 0) > 0)
      }).length
    },
    isTeacherUser () {
      const type = String(this.userInfo?.type ?? '')
      return type === '1' || Boolean(this.userInfo?.role && this.userInfo.role !== 'S' && this.userInfo.role !== 'P')
    },
    guardianType () {
      return this.isTeacherUser ? '1' : '0'
    }
  },
  mounted () {
    this.getStudentList()
  },
  methods: {
    /**
     * 返回页面顶部（Home 按钮）
     * @returns {void}
     */
    scrollToTop () {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    getStudentList () {
      const guardianId = this.userInfo.id
      getUserList(guardianId, this.guardianType).then((res) => {
        if (res.code !== 200) {
          return false
        }
        this.studentList = res.data
      })
    },
    selectStudent (item) {
      this.selectStudentInfo =
        item.studentId === this.selectStudentInfo?.studentId ? null : item

      if (!this.selectStudentInfo) {
        return false
      }
      boundCategories(this.selectStudentInfo.studentId).then((res) => {
        if (res.code !== 200) {
          return false
        }
        this.categoriesList = res.data
        this.pointCode = res.data[0].id
        this.getKnowledgeStats()
      })
    },
    /**
     * 获取知识点统计数据并渲染柱状图
     * @returns {void}
     */
    getKnowledgeStats () {
      if (!this.selectStudentInfo || !this.pointCode) {
        return
      }
      const params = {
        studentId: this.selectStudentInfo.studentId,
        categoryId: this.pointCode
      }
      this.knowledgeLoading = true
      knowledgeStats(params)
        .then((res) => {
          if (res.code !== 200 || !res.data) {
            return
          }
          const items = Array.isArray(res.data.items) ? res.data.items : []
          const xAxisData = items.map((item) =>
            this.$i18n.locale === 'en' ? item.pointName : item.pointNameFr
          )
          const correctRateList = items.map((item) =>
            Number(item.correctRate || 0)
          )
          const completionList = items.map((item) =>
            Number(item.completionPercentage || 0) * 100
          )
          this.$nextTick(() => {
            this.initKnowledgeChart(xAxisData, correctRateList, completionList)
          })
        })
        .catch(() => {
          // ignore error, loading 状态在 finally 中处理
        })
        .finally(() => {
          this.knowledgeLoading = false
        })
    },
    /**
     * 切换知识分类时重新获取统计数据
     * @returns {void}
     */
    handleCategoryChange () {
      this.getKnowledgeStats()
    },
    /**
     * 初始化或更新知识点柱状图
     * @param {Array<string>} xAxisData 横坐标知识点名称
     * @param {Array<number>} correctRateList 正确率数据
     * @param {Array<number>} completionList 学习进度数据
     * @returns {void}
     */
    initKnowledgeChart (xAxisData, correctRateList, completionList) {
      const chartDom = this.$refs.knowledgeChart
      if (!chartDom) {
        return
      }
      if (!this.knowledgeChart) {
        this.knowledgeChart = echarts.init(chartDom)
        window.addEventListener('resize', this.resizeKnowledgeChart)
      }
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter (params) {
            const lines = params.map((p) => {
              return `${p.seriesName}: ${p.value}%`
            })
            return `${params[0].axisValue}<br/>${lines.join('<br/>')}`
          }
        },
        legend: {
          top: 10,
          left: 12,
          itemWidth: 10,
          itemHeight: 10,
          icon: 'roundRect',
          textStyle: {
            color: '#475569',
            fontSize: 12,
            fontWeight: 700
          },
          data: ['Correct Rate', 'Completion Percentage']
        },
        grid: {
          left: 14,
          right: 18,
          top: 48,
          bottom: 16,
          containLabel: true
        },
        xAxis: {
          type: 'value',
          min: 0,
          max: 100,
          splitLine: { show: false },
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: {
            formatter: '{value}%',
            color: '#94a3b8',
            fontWeight: 700
          }
        },
        yAxis: {
          type: 'category',
          data: xAxisData,
          axisLabel: {
            interval: 0,
            margin: 14,
            color: '#64748b',
            fontWeight: 700
          },
          axisLine: { show: false },
          axisTick: { show: false }
        },
        series: [
          {
            name: 'Correct Rate',
            type: 'bar',
            data: correctRateList,
            showBackground: true,
            backgroundStyle: {
              color: '#eef2ff',
              borderRadius: 999
            },
            itemStyle: {
              color: '#6366f1',
              borderRadius: 999
            },
            barMaxWidth: 10,
            barGap: '55%'
          },
          {
            name: 'Completion Percentage',
            type: 'bar',
            data: completionList,
            showBackground: true,
            backgroundStyle: {
              color: '#ecfdf5',
              borderRadius: 999
            },
            itemStyle: {
              color: '#22c55e',
              borderRadius: 999
            },
            barMaxWidth: 10
          }
        ]
      }
      this.knowledgeChart.setOption(option, true)
    },
    /**
     * 自适应调整知识点柱状图大小
     * @returns {void}
     */
    resizeKnowledgeChart () {
      if (this.knowledgeChart) {
        this.knowledgeChart.resize()
      }
    },
    toAddBinding () {
      this.$refs.addBinding.show()
    },
    close () {
      this.selectStudentInfo = null
      this.categoriesList = []
      this.pointCode = ''
      this.knowledgeChart = null
    },
    deleteBing (relationId = null) {
      const id = relationId || this.selectStudentInfo.relationId
      deleteBing(id).then((res) => {
        if (res.code !== 200) {
          return false
        }
        this.studentList = this.studentList.filter(
          (item) => item.relationId !== id
        )
        this.selectStudentInfo = null
      })
    },
    toStudentHomepage () {
      this.$router.push({
        path: '/studentHomepage',
        query: {
          userId: this.selectStudentInfo.studentId,
          studentName: this.selectStudentInfo.studentName,
          grade: this.selectStudentInfo.studentGrade
        }
      })
    }
  },
  beforeDestroy () {
    if (this.knowledgeChart) {
      this.knowledgeChart.dispose()
      this.knowledgeChart = null
    }
    window.removeEventListener('resize', this.resizeKnowledgeChart)
  }
}
</script>

<style scoped>
/* 页面基底：与 studentHomepage / studentLearn 统一的淡紫渐变 */
.parent-dashboard {
  --pd-purple: #7c4dff;
  --pd-purple-deep: #5b21b6;
  --pd-orange: #ff8a00;
  --pd-radius: 24px;
  --pd-muted: #64748b;
}

.parent-dashboard.container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  min-height: calc(100% - 90px);
  padding: 12px 16px;
  box-sizing: border-box;
  background: linear-gradient(180deg, #f3e8ff 0%, #ede7f6 45%, #e8e0f5 100%);
}

.page-tagline {
  width: 100%;
  max-width: 1480px;
  text-align: center;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.12em;
  color: #fff;
  background: var(--pd-purple-deep);
  padding: 8px 16px;
  border-radius: 999px;
  margin-bottom: 12px;
}

.parent-dashboard .footer{
  margin-top: 16px;
  font-weight: 400;
  font-size: 11px;
  color: #94a3b8;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  text-align: center;
}

.parent-dashboard .box {
  width: 100%;
  max-width: 1443px;
  min-height: 780px;
  display: flex;
  flex-direction: column;
}

/* Hero */
.hero {
  border-radius: var(--pd-radius);
  overflow: hidden;
  margin-bottom: 18px;
  box-shadow: 0 12px 40px rgba(91, 33, 182, 0.18);
}

.hero-main {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 22px 26px;
  background: linear-gradient(115deg, #7c4dff 0%, #6366f1 45%, #2563eb 100%);
}

.hero-left {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
  min-width: 240px;
}

.hero-icon {
  width: 50px;
  height: 50px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 24px;
  flex-shrink: 0;
}

.hero-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
}

.badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  color: #fff;
  background: rgba(255, 255, 255, 0.18);
}

.badge--accent {
  background: rgba(255, 138, 0, 0.95);
  box-shadow: 0 4px 14px rgba(255, 138, 0, 0.35);
}

.hero-title {
  margin: 0;
  font-size: 26px;
  font-weight: 800;
  color: #fff;
  line-height: 1.2;
}

.hero-sub {
  margin: 6px 0 0;
  font-size: 14px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.92);
}

.hero-name {
  font-weight: 800;
  margin: 0 4px;
}

.hero-stats {
  display: flex;
  gap: 28px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.hero-stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 78px;
}

.hero-stat-num {
  font-size: 26px;
  font-weight: 800;
  color: #fff;
  line-height: 1.1;
}

.hero-stat-label {
  margin-top: 6px;
  font-size: 12px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.85);
}

.hero-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 16px 16px;
  border: none;
  border-radius: 999px;
  cursor: pointer;
  font-weight: 800;
  font-size: 16px;
  transition: transform 0.2s, box-shadow 0.2s, opacity 0.2s;
  white-space: nowrap;
}

.btn:hover {
  transform: translateY(-1px);
}

.btn--primary {
  background: linear-gradient(90deg, #7c4dff 0%, #5b21b6 100%);
  color: #fff;
  box-shadow: 0 8px 24px rgba(91, 33, 182, 0.28);
}

.btn--orange {
  background: var(--pd-orange);
  color: #fff;
  box-shadow: 0 6px 20px rgba(255, 138, 0, 0.45);
}

.btn--ghost {
  background: rgba(124, 77, 255, 0.1);
  color: var(--pd-purple-deep);
}

.hero-strip {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 14px;
  padding: 12px 18px;
  background: rgba(49, 20, 120, 0.42);
  backdrop-filter: blur(6px);
}

.strip-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border: none;
  background: transparent;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  cursor: default;
  border-radius: 12px;
  opacity: 0.88;
}

.strip-link.is-active {
  opacity: 1;
  background: rgba(255, 255, 255, 0.12);
}

/* Section head */
.section-head {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
  margin: 4px 4px 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(124, 77, 255, 0.15);
}

.section-head-left {
  display: flex;
  align-items: baseline;
  gap: 12px;
}

.section-tab {
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.12em;
  color: var(--pd-purple-deep);
  text-transform: uppercase;
  padding-bottom: 6px;
  border-bottom: 4px solid var(--pd-purple);
}

.section-count {
  font-size: 14px;
  color: #94a3b8;
  font-weight: 600;
}

/* Cards */
.content {
  margin: 0 4px;
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  overflow-y: auto;
  padding: 6px 0 10px;
  gap: 20px;
  align-content: flex-start;
}

.card {
  width: calc(100% / 3 - 14px);
  min-width: 260px;
  flex: 1 1 calc(33.333% - 14px);
  max-width: calc(33.333% - 14px);
  min-height: 300px;
  background: #ffffff;
  padding: 22px 20px 18px;
  display: flex;
  flex-direction: column;
  border-radius: 18px;
  box-shadow: 0 4px 20px rgba(15, 23, 42, 0.06);
  border: 1px solid rgba(226, 232, 240, 0.95);
  cursor: pointer;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}
.user{
  display: flex;
  margin-bottom: 24px;
}
.name{
  margin-left: 24px;
}

.card:hover{
  transform: translateY(-4px);
  box-shadow: 0 16px 40px rgba(91, 33, 182, 0.12);
}

.avatar-wrap {
  width: 76px;
  height: 76px;
  border-radius: 22px;
  background: linear-gradient(145deg, #ede7ff 0%, #f5f3ff 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
}

.avatar-wrap img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
}

.student-name {
  margin-top: 8px;
  font-weight: 900;
  font-size: 22px;
  color: #0f172a;
}

.grade-line {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
}

.grade-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 999px;
  font-weight: 800;
  font-size: 12px;
  background: #ede7f6;
  color: var(--pd-purple-deep);
  margin-right: 12px;
}

.status-pill {
  display: inline-flex;
  align-items: center;
  padding: 6px 10px;
  border-radius: 999px;
  font-weight: 800;
  font-size: 12px;
  background: #dcfce7;
  color: #166534;
}

.learning-progress {
  width: 100%;
}

.learning-progress .category {
  margin: 14px 0 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.learning-progress .name {
  font-weight: 800;
  font-size: 14px;
  color: #475569;
  margin-left: 0;
}

.learning-progress .progress {
  font-weight: 700;
  font-size: 13px;
  color: #94a3b8;
}

.content ::v-deep .el-progress-bar__outer {
  border-radius: 999px;
  background-color: #f1f5f9;
}

.content ::v-deep .el-progress-bar__inner {
  border-radius: 999px;
}

.card-actions {
  display: flex;
  width: 100%;
  gap: 10px;
  margin-top: 16px;
}

.btn-mini {
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 48px;
  border-radius: 999px;
  border: none;
  cursor: pointer;
  font-weight: 800;
  font-size: 13px;
  transition: transform 0.2s, opacity 0.2s, box-shadow 0.2s;
}

.btn-mini:hover {
  transform: translateY(-1px);
}

.btn-mini--primary {
  background: linear-gradient(90deg, #7c4dff 0%, #5b21b6 100%);
  color: #fff;
  box-shadow: 0 8px 20px rgba(91, 33, 182, 0.22);
}

.btn-mini--danger {
  background: #fee2e2;
  color: #b91c1c;
}

/* Bottom CTA */
.cta-bar {
  margin-top: 12px;
  padding: 18px 22px;
  border-radius: var(--pd-radius);
  background: #ede7f6;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border: 1px solid rgba(124, 77, 255, 0.12);
}

.cta-left {
  display: flex;
  align-items: center;
  gap: 14px;
  flex: 1;
  min-width: 220px;
}

.cta-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: linear-gradient(145deg, #8b5cf6, #6d28d9);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 22px;
  flex-shrink: 0;
}

.cta-title {
  margin: 0;
  font-size: 16px;
  font-weight: 900;
  color: #1e1b4b;
}

.cta-sub {
  margin: 4px 0 0;
  font-size: 13px;
  color: var(--pd-muted);
}

@media (max-width: 1200px) {
  .card {
    max-width: calc(50% - 10px);
    flex: 1 1 calc(50% - 10px);
  }
}

@media (max-width: 720px) {
  .hero-stats {
    width: 100%;
    justify-content: space-between;
  }
  .card {
    max-width: 100%;
    flex: 1 1 100%;
  }
}

.student-Details {
  width: 100%;
  height: calc(100% - 90px);
  position: absolute;
  top: 90px;
  background: rgba(17, 24, 39, 0.55);
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(6px);
}

.student-Details .info {
  width: min(900px, 92vw);
  height: min(880px, 86vh);
  background: #ffffff;
  box-shadow: 0 26px 90px rgba(91, 33, 182, 0.28);
  border-radius: 18px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  position: relative;
  overflow: hidden;
}

/* 顶部渐变标题栏（带左侧小图标） */
.student-Details .info .details {
  height: 56px;
  padding: 0 16px 0 52px;
  display: flex;
  align-items: center;
  font-weight: 900;
  font-size: 15px;
  color: #ffffff;
  background: linear-gradient(90deg, #7c4dff 0%, #6366f1 50%, #3b82f6 100%);
  position: relative;
}

.student-Details .info .details::before {
  content: '';
  position: absolute;
  left: 16px;
  top: 50%;
  width: 26px;
  height: 26px;
  transform: translateY(-50%);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.2);
}

.student-Details .info .details::after {
  content: '▮▮▮';
  position: absolute;
  left: 23px;
  top: 50%;
  transform: translateY(-52%);
  font-size: 10px;
  letter-spacing: -2px;
  color: rgba(255, 255, 255, 0.92);
}

/* 关闭按钮（右上角白色圆形） */
.student-Details .info .close {
  position: absolute;
  right: 14px;
  top: 12px;
  width: 32px;
  height: 32px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.9);
  color: #4b5563;
  font-size: 16px;
  cursor: pointer;
  box-shadow: 0 10px 26px rgba(15, 23, 42, 0.18);
}

.student-Details .info .close:hover {
  opacity: 0.92;
}

/* 主体：头像 + 名称 + 年级 + Remove */
.student-Details .info img {
  position: absolute;
  top: 78px;
  left: 22px;
  width: 56px;
  height: 56px;
  border-radius: 16px;
  object-fit: cover;
  background: #ede9fe;
}

.student-Details .info .student-name {
  margin-top: 18px;
  padding: 18px 22px 0 94px;
  font-weight: 900;
  font-size: 16px;
  color: #0f172a;
}

.student-Details .info .grade {
  padding: 6px 22px 0 94px;
  font-weight: 800;
  font-size: 12px;
  color: #5b21b6;
}

.student-Details .info .grade span {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  background: #ede7f6;
  color: #5b21b6;
  font-weight: 900;
  margin-left: 0 !important;
}

.student-Details .info .delete {
  position: absolute;
  right: 22px;
  top: 88px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 999px;
  background: rgba(239, 68, 68, 0.06);
  color: #ef4444;
  font-weight: 900;
  font-size: 13px;
  cursor: pointer;
}

.student-Details .info .delete i {
  font-size: 14px;
}

/* 分类下拉（全宽，贴近截图） */
.student-Details .info .button.el-select{
  width: calc(100% - 44px);
  margin: 18px 22px 0;
}

.student-Details .info .button.el-select ::v-deep .el-input__inner{
  height: 44px;
  line-height: 44px;
  border-radius: 14px;
  border: 1px solid #e5e7eb;
  background: #f5f3ff;
  box-shadow: none;
  font-weight: 900;
  font-size: 14px;
  color: #111827;
  padding-left: 44px;
}

.student-Details .info .button.el-select ::v-deep .el-input__prefix{
  left: 14px;
  color: #7c4dff;
}

.student-Details .info .button.el-select ::v-deep .el-input__suffix{
  right: 14px;
}

.student-Details .info .button.el-select ::v-deep .el-input__inner::placeholder{
  font-weight: 900;
  font-size: 14px;
  color: #94a3b8;
}

/* 图表区域：留白 + 可滚动 */
.student-Details .info .knowledge-chart{
  flex: 1;
  min-height: 0;
  width: calc(100% - 44px);
  margin: 14px 22px 22px;
  border-radius: 14px;
  background: #ffffff;
  border: 1px solid rgba(124, 77, 255, 0.12);
  overflow: hidden;
}

/* ECharts 视觉微调（让图表更像设计稿） */
.student-Details .info .knowledge-chart ::v-deep canvas {
  border-radius: 14px;
}
</style>
